// extracted by mini-css-extract-plugin
export default {"valueItem":"ValueItem_valueItem__xDKWG","discount":"ValueItem_discount__HdHdv","selectedValueItem":"ValueItem_selectedValueItem__zbJdl"};